import useDictionary from 'lib/sitecore/use-dictionary';
import { classnames } from 'tailwindcss-classnames';
import { getSalesforceFlowData, SalesForceData } from 'lib/sitecore/sitecore-cdp';
import { useEffect, useState } from 'react';
import useCdpLoaded from 'lib/util/useCdpLoaded';
import useExperienceEditor from 'lib/sitecore/use-experience-editor';
import AlertWarning from 'components/helpers/SvgIcon/icons/alert-warning';

export interface MyCentersProps {
  fields?: {};
}

export type myCentersData = {
  getguestCenterData?: React.ReactNode;
};
export type objCenterData = {
  centerId?: string;
  centerName?: string;
  centerNameTwo?: string;
  centerStreet?: string;
  centerCity?: string;
  centerState?: string;
  centerCountry?: string;
  centerZip?: string;
  centerPhone?: string;
  centerTollFree?: string;
};

const MyCenters = () => {
  const dictionary = useDictionary();

  const prevMyCenterData: myCentersData = {
    getguestCenterData: '',
  };
  const [formData, setFormData] = useState<myCentersData>(prevMyCenterData);
  const boxeverLoaded = useCdpLoaded();
  const mapsApiKey = process.env.GOOGLE_MAPS_API_KEY;
  const fontMedium = 'font-medium';
  const textSolidBlack = classnames(`text-solidBlack`);

  useEffect(() => {
    if (boxeverLoaded) {
      getSalesforceFlowData().then((res: SalesForceData): void => {
        const salesforceContact = res;
        if (salesforceContact && salesforceContact.profileData) {
          const formCenterData = JSON.parse(
            salesforceContact.profileData.guestCenterData as string
          );

          if (formCenterData && formCenterData.length > 0) {
            const mapData = formCenterData.map((el: objCenterData) => {
              const mapURL = encodeURIComponent(
                `${el?.centerStreet} ${el?.centerCity} ${el?.centerState} ${el?.centerZip}`
              );

              return (
                <div
                  key={el.centerId}
                  className={classnames(
                    'w-full',
                    'flex',
                    'mb-10',
                    'h-auto',
                    'flex-col',
                    'md:flex-row'
                  )}
                >
                  <div
                    className={classnames(
                      'w-full',
                      'md:w-1/3',
                      'border-t',
                      'border-gray-midGray',
                      'md:mr-8'
                    )}
                  >
                    <h2
                      className={classnames(
                        'text-lg',
                        fontMedium,
                        'pt-4',
                        'pb-2',
                        'md:text-2xl',
                        'md:pt-5',
                        'md:pb-6',
                        'md:leading-9'
                      )}
                    >
                      {el?.centerName}
                    </h2>
                    <div className={classnames('pt-2', 'text-body', fontMedium, textSolidBlack)}>
                      {dictionary.mycenters_center_type} - {el?.centerId}
                    </div>
                    <div className={classnames('py-2', textSolidBlack)}>
                      <address>
                        {el?.centerStreet} <br />
                        {el?.centerCity}, {el?.centerState} {el?.centerZip}
                      </address>
                    </div>
                    <div className={classnames('pt-2', 'flex', 'flex-wrap', textSolidBlack)}>
                      <span>{dictionary.myprofile_phone}:</span>
                      <a
                        className={classnames('text-blue', 'hover:underline')}
                        href={el?.centerPhone}
                      >
                        {el?.centerPhone}
                      </a>
                    </div>
                    <div className={classnames('pt-2', 'flex', 'flex-wrap', textSolidBlack)}>
                      <span>{dictionary.mycenters_toll_free}:</span>
                      <a
                        className={classnames('text-blue', 'hover:underline')}
                        href={el?.centerTollFree}
                      >
                        {el?.centerTollFree}
                      </a>
                    </div>
                  </div>

                  <div
                    className={classnames(
                      'h-60',
                      'pt-4',
                      'w-full',
                      'md:w-2/3',
                      'md:pt-0',
                      'md:h-96'
                    )}
                  >
                    <iframe
                      className={classnames('w-full', 'h-full')}
                      title="MyCenters"
                      src={`https://www.google.com/maps/embed/v1/place?key=${mapsApiKey}&q=${mapURL}`}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      loading="lazy"
                    />
                  </div>
                </div>
              );
            });

            setFormData({
              getguestCenterData: mapData,
            });
          }
        } else {
          // Handle the case when salesforceContact or profileData is not available
          setFormData({
            getguestCenterData: (
              <div
                className={classnames(
                  'w-full',
                  'flex',
                  'mb-10',
                  'h-auto',
                  'flex-col',
                  'md:flex-row'
                )}
              >
                <div
                  className={classnames(
                    'rounded',
                    'mb-4',
                    'py-4',
                    'px-6',
                    'flex',
                    'text-black',
                    'leading-4',
                    'lg:mb-6'
                  )}
                >
                  <span className={classnames('pr-2')}>
                    <AlertWarning />
                  </span>
                  {dictionary.No_Data_Message}
                </div>
              </div>
            ),
          });
        }
      });
    }
  }, [
    boxeverLoaded,
    dictionary.No_Data_Message,
    dictionary.mycenters_center_type,
    dictionary.mycenters_toll_free,
    dictionary.myprofile_phone,
    mapsApiKey,
    textSolidBlack,
  ]);

  const myCenter = formData?.getguestCenterData;
  const isEE = useExperienceEditor();
  if (isEE) {
    return <div className={classnames('heading-md')}>My Centers will be shown here</div>;
  }
  return (
    <div data-component="authorable/utility-nav/mycenters">
      {/* // My Centers */}
      <div>{myCenter}</div>
    </div>
  );
};

export default MyCenters;
